/* tslint:disable */
/* eslint-disable */
/**
 * SoudniSpory
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum TypObjektEnum {
    /**
    * Parcela
    */
    PARCELA = 'PARCELA',
    /**
    * Budova
    */
    BUDOVA = 'BUDOVA',
    /**
    * Byt
    */
    BYT = 'BYT',
    /**
    * Nebytový prostor
    */
    NEBYT = 'NEBYT',
    /**
    * Plocha
    */
    PLOCHA = 'PLOCHA',
    /**
    * Síť
    */
    SIT = 'SIT',
    /**
    * Předmět
    */
    PREDMET = 'PREDMET',
    /**
    * Stavba
    */
    STAVBA = 'STAVBA',
    /**
    * Sloup
    */
    SLOUP = 'SLOUP',
    /**
    * Hrobové místo
    */
    HROB = 'HROB',
    /**
    * Prvek
    */
    PRVEK = 'PRVEK',
    /**
    * Právo stavby
    */
    PS = 'PS',
    /**
    * Věcné břemeno
    */
    PRAVO = 'PRAVO'
}


